import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React, { useState } from "react";
import * as style from "./style.module.css";
import json from "/src/siteData.json";
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import line from "/src/images/icon/line.png";
import logo from "/src/images/top/logo2.png";

const logoUri = json.header.logoUri;
const siteMetaData = json.siteMetadata;
const footer = json.footer;
const pageConstruct = json.pageConstruct;
const phoneNumber = json.footer.phoneNumber;
let pageConstructAddition = pageConstruct.concat();

const Component = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [thisOpen, setThisOpen] = useState(false);
  const [thisOpen1, setThisOpen1] = useState(false);

  return (
    <header>
      <h1>
        <Link to="/" className={style.logo}>
          <img
            src={logo}
            alt={siteMetaData.title}
            style={{ objectFit: "contain" }}
          />
        </Link>
      </h1>
      <div className={style.header_right}>
        <div className={style.line_link}>
          <p>下記のボタンをクリックして「友だちを追加」</p>
          <Link
            to="https://page.line.me/489fcyqw?openQrModal=true"
            target="_brank"
          >
            <img src={line} alt="LINEアイコン" />
            無料相談
          </Link>
        </div>
        <button
          className={style.menu}
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          {!isOpen ? (
            <StaticImage
              src="../../images/icon/menu-open.png"
              placeholder="none"
              loading="eager"
              formats={["auto", "webp", "avif"]}
              style={{ width: "32px" }}
              alt="開く"
            />
          ) : null}
        </button>

        {isOpen ? (
          <div className={style.sp_menu}>
            <button
              className={style.close_btn}
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              <StaticImage
                src="../../images/icon/menu-close.png"
                placeholder="none"
                loading="eager"
                formats={["auto", "webp", "avif"]}
                style={{ width: "32px" }}
                alt="閉じる"
              />
            </button>
            <nav className={style.sp_nav}>
              <ul className={style.sp_nav_list}>
                <li className={style.sp_nav_item}>
                  <Link to="/">ホーム</Link>
                </li>
                <li className={style.sp_nav_item}>
                  <Link to={getPathFromTemplateType(4)}>お知らせ</Link>
                </li>
                <li className={style.sp_nav_item}>
                  <Link to="/omoi">理念</Link>
                </li>
                <li className={style.sp_nav_item}>
                  <Link to="/about">中学受験について</Link>
                </li>
                <li className={style.sp_nav_item}>
                  <Link to="/flow">入塾までの流れと受講料</Link>
                </li>
                <li className={style.sp_nav_item}>
                  <Link to="/passed">合格実績</Link>
                </li>
                <li className={style.sp_nav_item}>
                  <Link to="/faq">よくある質問</Link>
                </li>
                <li className={style.sp_nav_item}>
                  <Link to="/kaisetu">プリント＆動画</Link>
                </li>
                <li className={style.sp_nav_item}>
                  <Link to="/recruit/office_part/">採用情報</Link>
                </li>
                <li className={style.sp_nav_item}>
                  <Link to={getPathFromTemplateType(6)}>お問い合わせ</Link>
                </li>
                <li className={style.sp_nav_item}>
                  <Link to={getPathFromTemplateType(5)}>
                    プライバシーポリシー
                  </Link>
                </li>
                {/* <li className={style.sp_nav_item}>
                  <Link to="/class">学年別クラス</Link>
                </li> */}
              </ul>
              {/* <div className={style.spcontact}>
              <a className={style.tel} href={`tel:+81${phoneNumber}`}>
                <FontAwesomeIcon icon={faPhone}/>
                {phoneNumber}
              </a>
              <Link to={getPathFromTemplateType(6)}>お問い合わせ</Link>
            </div> */}
              <div className={style.sns_link}>
                {footer.facebookUrl && (
                  <Link to={footer.facebookUrl}>
                    <StaticImage
                      src="../../images/icon/sns-facebook-wh.svg"
                      placeholder="none"
                      loading="eager"
                      formats={["auto", "webp", "avif"]}
                      alt="facebook"
                    />
                  </Link>
                )}
                {footer.instagramUrl && (
                  <Link to={footer.instagramUrl}>
                    <StaticImage
                      src="../../images/icon/sns-instagram-wh.svg"
                      placeholder="none"
                      loading="eager"
                      formats={["auto", "webp", "avif"]}
                      alt="instagram"
                    />
                  </Link>
                )}
                {footer.lineUrl && (
                  <Link to={footer.lineUrl}>
                    <StaticImage
                      src="../../images/icon/sns-line-wh.svg"
                      placeholder="none"
                      loading="eager"
                      formats={["auto", "webp", "avif"]}
                      alt="line"
                    />
                  </Link>
                )}
                {footer.xUrl && (
                  <Link to={footer.xUrl}>
                    <StaticImage
                      src="../../images/icon/sns-x-wh.svg"
                      placeholder="none"
                      loading="eager"
                      formats={["auto", "webp", "avif"]}
                      alt="x"
                    />
                  </Link>
                )}
              </div>
            </nav>
          </div>
        ) : null}
      </div>
    </header>
  );
};

export default Component;
